import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../../api.types';
import { UpdateMemberBadgesRequest, ViewmemberBadgesRequest } from './member-badge.types';

export const requestViewMemberBadges = createAction<SagaPayload<ViewmemberBadgesRequest>['payload']>(
  'request/requestViewMemberBadges'
);

export const requestModifyMemberBadges = createAction<SagaPayload<UpdateMemberBadgesRequest>['payload']>(
  'request/requestModifyMemberBadges'
);
